import template from './createPocModal.html';
import controller from './createPocModal.controller';

let CreatePocModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

export default CreatePocModalComponent;




// WEBPACK FOOTER //
// ./client/pages/admin/customer-details/modals/createPocModal/createPocModal.component.js